module.exports = __webpack_public_path__ + "img/navRightTop.ea1f146d.png";